module.exports = __webpack_public_path__ + "media/images/raining-money-61c1c1cf.png";